<section class="modal w-screen h-screen left-0 bottom-0 fixed" #modal>
    <div class="ngx-overlay fixed inset-0 bg-black z-40 opacity-70 h-screen" #overlay (click)="onClose()"></div>

    <div #content
        class="ngx-modal bg-white z-50 absolute bottom-0 inset-x-0 rounded-t-3xl px-6 py-7 max-h-full overflow-y-auto"
    >
        <ng-content></ng-content>
    </div>
</section>
